<template>
    <div :class="isAfert ? 'entity-compare-after' : ''">
        <div>
            <div class="tab-sub-heading">
                <h3>{{ t('laboratories::form.title.general_information') }}</h3>
            </div>
            <div class="notification-field name">
                <label class="label"
                    >{{ t('laboratories::form.label.number') }} {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ store.name }}</div>
            </div>
            <div class="notification-field is_registered">
                <label class="label">{{ t('laboratories::form.label.registered') }}</label>
                <div class="value">{{ getStatus(store.is_registered) }}</div>
            </div>
            <div class="notification-field prn">
                <label class="label">{{ t('collection-centre::form.label.prn') }}</label>
                <div class="value">{{ store.prn }}</div>
            </div>
            <div class="tab-sub-heading">
                <h3>{{ t('laboratories::form.title.address') }}</h3>
            </div>
            <div class="notification-field address">
                <label class="label"
                    >{{ t('laboratories::form.label.address') }} {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ store.address }}</div>
            </div>
            <div class="notification-field post_code">
                <label class="label"
                    >{{ t('laboratories::form.label.post_code') }} {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ store.post_code }}</div>
            </div>

            <div class="tab-sub-heading">
                <h3>{{ t('laboratories::form.title.contact_details') }}</h3>
            </div>
            <div class="notification-field phone">
                <label class="label"
                    >{{ t('laboratories::form.label.phone') }} {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ store.phone }}</div>
            </div>
            <div class="notification-field fax">
                <label class="label">{{ t('laboratories::form.label.fax') }}</label>
                <div class="value">{{ store.fax }}</div>
            </div>
            <div class="notification-field email">
                <label class="label"
                    >{{ t('laboratories::form.label.email') }} {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ store.email }}</div>
            </div>
            <div class="tab-sub-heading">
                <h3>{{ t('laboratories::form.title.npt_device') }}</h3>
            </div>
            <div class="notification-field npt_device_id">
                <label class="label">{{ t('laboratories::form.label.npt_device') }}</label>
                <div class="value">{{ getSelectItem(nptDevicesOptions, store.npt_device_id) }}</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'NotificationLaboratoriesApprovalRequestForm',
    components: {},
    props: {
        store: {
            type: Object,
            required: true,
        },
        isAfert: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {};
    },
    computed: {
        updatedProps() {
            return this.$store.state.notification_laboratory.updatedProps.map((x) => x.replace('.', '-'));
        },
        nptDevicesOptions() {
            return this.$store.state.laboratories.nptDevicesOptions.map((x) => ({ value: x.id, text: x.name }));
        },
    },
    watch: {
        updatedProps() {
            this.setActiveItems();
        },
    },
    mounted() {
        this.setActiveItems();
    },
    created() {},
    methods: {
        getStatus(status) {
            return status ? 'True' : 'False';
        },
        getSelectItem(items, value) {
            return items.find((x) => x.value === value) ? items.find((x) => x.value === value).text : null;
        },
        setActiveItems() {
            if (!this.updatedProps.length) {
                return;
            }
            this.updatedProps.forEach((props) => {
                const field = this.$el.querySelector(`.${props}`);
                // console.warn('props', field ? field : props);
                if (field) {
                    field.classList.add('updated');
                }
            });
        },
    },
};
</script>
